export const GelViewConfig = Symbol.for('drizzle:GelViewConfig');
